import {useParams} from "react-router-dom";
import categories from "./data/categories.json";
import DefaultHelmet from "./components/DefaultHelmet";
import Breadcrumb from "./components/Navigation/Breadcrumb";
import {useContext} from "react";
import {AppContext} from "./App";
import {getCityName} from "./components/Property/PropertyHelper";
import PropertyDetails from "./components/Property/PropertyDetails";
import PromotionDetails from "./components/Promotion/PromotionDetails";

function Page({title, props, component: Component}) {
    const {type, city} = useParams();
    const {citiesLoading} = useContext(AppContext);

    if (typeof type !== "undefined") {
        props.types.push((categories.find(category => category.urlValue === type)?.name));
    }

    if (typeof city !== "undefined") {
        const postalCode = city.split("-")[city.split("-").length - 1];
        props.cities.push(postalCode)
    }

    if (!title) {
        const typePart = "Nos " + (typeof type !== "undefined" ? (type + "s") : "biens");
        const actionTypePart = " à " + props.actionType.toLowerCase();

        const cityPart = typeof city !== "undefined" ?
            (" à " + getCityName(city.split("-")[0], city.split("-")[city.split("-").length - 1]))
            : "";

        title = typePart + actionTypePart + (citiesLoading ? "" : cityPart);
    }

    return (
        <>
            <DefaultHelmet title={title}/>
            <div className={"py-10 pt-28 md:pt-44 min-h-screen"}>
                <Breadcrumb className="ml-2 md:ml-6 mb-4" title={title ? title : ""} props={props}/>
                {title && Component !== PropertyDetails && Component !== PromotionDetails ?
                    <h1 className="mx-auto w-full md:w-4/5 px-2 md:px-0 text-3xl md:text-5xl text-primary mb-2 md:mb-6">{title}</h1> : ""}
                <Component
                    props={props}/>
            </div>
        </>
    );
}

export default Page;